
<!-- Header display with summary info -->
<div class="row px-5 py-2 info-box">
  @if (projectWBS) {
    @if (!isPortfolio) {
      @if (selectedProjectInfo !== undefined) {
        <app-lock [lockedState]="!!selectedProjectInfo[0].lock"></app-lock>
        <app-info-project
          [projectInfo]="selectedProjectInfo[0]"
          [projectTitle]="selectedName"
          [accessLevel]="accessLevel()"
          [hasNotificationsOn]="hasNotificationsOn"
          [hasProjectOwner]="hasProjectOwner"
          [extAssignment]="extAssignment"
          [extExpense]="extExpense"
          [extChanges]="extChanges"
          [isSiteAdmin]="isSiteAdmin"
          [isGlobalAdmin]="isGlobalAdmin"
          [lockedState]="lockedState"
          [isArchived]="isArchived()"
          [canLock]="canLock"
        ></app-info-project>
      }
    } @else {
      <app-lock [lockedState]="allLocked"></app-lock>
      <app-info-portfolio
        [projectInfo]="selectedProjectInfo"
        [portfolioTitle]="selectedName"
        [accessLevel]="accessLevel()"
        [extAssignment]="extAssignment"
        [extExpense]="extExpense"
        [extChanges]="extChanges"
        [isSiteAdmin]="isSiteAdmin"
        [isGlobalAdmin]="isGlobalAdmin"
        [lockedState]="lockedState"
        [isArchived]="isArchived()"
        [canLock]="canLock"
      ></app-info-portfolio>
    }
  }
</div>

<!-- Tab display showing different project info -->
<mat-tab-group (selectedTabChange)="tabChange($event)" [selectedIndex]="selectedTab" class="dense-6" [class.locked-padding]="!!selectedProjectInfo[0]?.lock" animationDuration="0">
  <!-- WBS -->
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon>list</mat-icon>
      WBS & Activities
    </ng-template>

    <ng-template matTabContent>
      @defer {
        <app-task-list [projectWBS]="projectWBS" [lockedState]="!!selectedProjectInfo[0]?.lock"></app-task-list>
      }
    </ng-template>
  </mat-tab>


  <!-- Restricted View Section to Site Admin -->
  @if (isSiteAdmin || accessLevel() >= PERMISSION_LEVEL.MGMT) {
    @if (extCharts) {
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>area_chart</mat-icon>
          Project Charts
        </ng-template>

        <ng-template matTabContent>
          @defer {
            <app-charts></app-charts>
          }
        </ng-template>
      </mat-tab>
    }

    @if (extChanges) {
      <!-- Site Admin Review -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>manage_search</mat-icon>
          Review Changes
        </ng-template>

        <ng-template matTabContent>
          @defer {
            <app-review></app-review>
          }
        </ng-template>
      </mat-tab>
    }
  }

  <!-- Assigned Work -->
  @if (extAssignment) {
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>assignment</mat-icon>
        Assigned Work
      </ng-template>
      <ng-template matTabContent>
        @defer {
          <app-assigned-work></app-assigned-work>
        }
      </ng-template>
    </mat-tab>

    <!-- Quick Work Assignment -->
    <!-- <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>playlist_add</mat-icon>
        Quick Assign
      </ng-template>
      <ng-template matTabContent>
        @if (projectWBS !== undefined) {
          <app-quick-assignment></app-quick-assignment>
        }
      </ng-template>
    </mat-tab> -->

    @if (accessLevel() >= PERMISSION_LEVEL.EDIT) {
      <!-- Contractors list -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>person</mat-icon>
          Contractors
        </ng-template>
        <ng-template matTabContent>
          @defer {
            <app-contractor-list></app-contractor-list>
          }
        </ng-template>
      </mat-tab>
    }
  }

  @if (extExpense) {
    @if (accessLevel() >= PERMISSION_LEVEL.READ) {
      <!-- Expense tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>monetization_on</mat-icon>
          Expense Tracking
        </ng-template>
        <ng-template matTabContent>
          @defer {
            <app-expense></app-expense>
          }
        </ng-template>
      </mat-tab>

      <!-- Signoff Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>draw</mat-icon>
          Sign-Off
        </ng-template>
        <ng-template matTabContent>
          @defer {
            <app-expense-signoff></app-expense-signoff>
          }
        </ng-template>
      </mat-tab>
    }
  }

  @if (isSiteAdmin) {
    @if (accessControl) {
      <!-- Project Permissions -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>key</mat-icon>
          Project Permissions
        </ng-template>
        <ng-template matTabContent>
          @defer {
            <app-project-permissions></app-project-permissions>
          }
        </ng-template>
      </mat-tab>
    }
  }

  @if (showSettings) {
    <!-- Project Settings -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>settings</mat-icon>
        Project Settings
      </ng-template>
      <ng-template matTabContent>
        @defer {
          <app-project-settings-page></app-project-settings-page>
        }
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>
